var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEnergySmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 48,
    viewBox: "0 0 35 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_413_68",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9117 0.280442L0.242367 32.0619C0.00469708 32.6569 0.424452 33.3089 1.04354 33.3089H17.6574C18.0868 33.3089 18.4509 33.6359 18.5142 34.0769L20.4654 47.6162C20.5305 48.0677 21.1266 48.1436 21.2953 47.7217L33.9646 15.938C34.2023 15.3431 33.7806 14.6911 33.1634 14.6911H16.5496C16.1202 14.6911 15.7561 14.3641 15.6928 13.9231L13.7416 0.383827C13.6764 -0.0676926 13.0804 -0.143649 12.9117 0.278332V0.280442Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_413_68)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.05786,
    y: -1.53601,
    width: 36.3227,
    height: 50.784,
    fill: "url(#paint0_linear_413_68)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.2858,
    cy: 43.152,
    rx: 26.6967,
    ry: 27.024,
    fill: "url(#paint1_radial_413_68)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.87788,
    cy: 37.584,
    rx: 26.6967,
    ry: 27.024,
    fill: "url(#paint2_radial_413_68)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76623,
    cy: 4.224,
    rx: 23.2826,
    ry: 30.336,
    fill: "url(#paint3_radial_413_68)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_413_68",
    x1: 17.1035,
    y1: -1.53601,
    x2: 17.1035,
    y2: 49.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA2D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_413_68",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.2858 43.152) rotate(90) scale(27.024 26.6967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#8C2462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2362",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_413_68",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.87788 37.584) rotate(90) scale(27.024 26.6967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#DB025D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC035C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_413_68",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.76623 4.224) rotate(90) scale(30.336 23.2826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FDD21E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCD1C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEnergySmall);
export default __webpack_public_path__ + "static/media/logo-energy-small.299c02905106967d849d18a569b19046.svg";
export { ForwardRef as ReactComponent };